import {
    Component,
    Input,
    ViewChild,
    ElementRef,
    HostBinding
} from '@angular/core';

import * as ScreepsMap from '@screeps/map';

@Component({
    selector: 'app-room',
    templateUrl: './room.component.pug',
    styleUrls: ['./room.component.less']
})
export class RoomComponent {
    @ViewChild('terrain', {static: true}) terrainRef: ElementRef<HTMLCanvasElement>;
    @ViewChild('objects', {static: true}) objectsRef: ElementRef<HTMLCanvasElement>;

    @Input() set terrain(terrain: string) {
        this.render(terrain);
    }

    _objects: any;
    @Input() set objects(objects: any) {
        console.log(objects);
        this._objects = objects;
    }

    constructor(
    ) {
    }

    render(terrain: string) {
        const data = ScreepsMap.roomTerrain(terrain);

        const id = new ImageData(new Uint8ClampedArray(data.buffer), 50, 50);
        const ctx = this.terrainRef.nativeElement.getContext('2d');
        ctx.putImageData(id, 0, 0);
    }

    drawObjects(objects: any, colors: any = {}) {
        const data = ScreepsMap.roomObjects(objects, colors);

        const id = new ImageData(new Uint8ClampedArray(data.buffer), 50, 50);
        const ctx = this.objectsRef.nativeElement.getContext('2d');
        ctx.putImageData(id, 0, 0);
    }
}
